/* eslint-disable prefer-rest-params */
import moment from 'moment';
import Cookies from 'js-cookie';
import wx from 'weixin-js-sdk';
import { reqReceivebatchCoupon, reqCommunity } from '@/api/coupon/index';
import { reqSchemeUrl } from '@/api/openMini';

export function dateTime(time) {
  const dateFormat = new Date(parseInt(time, 10));
  const year = dateFormat.getFullYear();
  const month = (dateFormat.getMonth() + 1).toString().padStart(2, '0');
  const day = dateFormat.getDate().toString().padStart(2, '0');
  const h = dateFormat.getHours().toString().padStart(2, '0');
  const m = dateFormat.getMinutes().toString().padStart(2, '0');
  const s = dateFormat.getSeconds().toString().padStart(2, '0');
  return {
    year,
    month,
    day,
    h,
    m,
    s,
  };
} // 时间格式处理
export function priceCount(price, type = 1) {
  // 价格拆分1:整数大，小数小。 2：一样大
  const p = parseFloat(price).toFixed(2).split('.');
  if (type === 1) {
    return {
      b: p[0], // big
      s: p[1] === '00' ? '' : `.${p[1]}`, // small
    };
  }
  return parseFloat(price).toFixed(2);
} // price：整数小数拆分
export function priceFilterFloat(price) {
  const p = parseFloat(price).toFixed(2).split('.');
  return `${p[0]}${p[1] === '00' ? '' : `.${p[1]}`}`;
} // priec 两位为00则过滤
export function dayCount(time) {
  const eleven = new Date();
  eleven.setHours(23);
  eleven.setMinutes(59);
  eleven.setSeconds(59);
  let day = '';
  // 1天为86400000毫秒  eleven.getTime()当天最大时间
  if (eleven.getTime() > time && eleven.getTime() - time < 86400000) {
    day = '今天';
  } else if (eleven.getTime() < time && time - eleven.getTime() < 86400000) {
    day = '明天';
  }
  return day;
} // 今天 明天
export function timerCount(t, type = 1) {
  // type: 1需要天数，其他则不需要
  const times = {};
  let d = parseInt(t / 1000 / 60 / 60 / 24, 10);
  let h = type === 2 ? parseInt((t / 1000 / 60 / 60) % 24, 10) : parseInt(t / 1000 / 60 / 60, 10);
  const m = parseInt((t / 1000 / 60) % 60, 10);
  const s = parseInt((t / 1000) % 60, 10);
  d = d > 99 ? 99 : d;
  h = h > 99 ? 99 : h;
  times.d = d < 10 ? `0${d}` : d;
  times.h = h < 10 ? `0${h}` : h;
  times.m = m < 10 ? `0${m}` : m;
  times.s = s < 10 ? `0${s}` : s;
  return times;
} // 倒计时
export function clickControl(el, type) {
  // el传入dom元素,注意el名称避免重复; type: 1为置灰防连点，2为解除防连点;
  const domClass = document.querySelector(el).classList;
  if (type === 1) {
    domClass.add('becomeGrey');
  } else {
    domClass.remove('becomeGrey');
  }
} // 防连点
export const setBaseUrl = (type = 1) => {
  let currentEnv = '';
  let baseUrl = '';
  ['pre.iqihang', 'release.iqihang', 'test.iqihang', 'dev.iqihang'].forEach((item) => {
    if (window.location.href.indexOf(item) !== -1) {
      currentEnv = item;
    }
  });
  // 本地开发环境
  // console.log(process.env);
  if (process.env.NODE_ENV === 'development') {
    currentEnv = 'test.iqihang';
  }
  switch (currentEnv) {
    case 'dev.iqihang':
      baseUrl = 'https://mobile-dev.iqihang.com';
      break;
    case 'test.iqihang':
      baseUrl = 'https://mobile-test.iqihang.com';
      break;
    case 'pre.iqihang':
      baseUrl = 'https://mobile-pre.iqihang.com';
      break;
    case 'release.iqihang':
      baseUrl = 'https://mobile-release.iqihang.com';
      break;
    default:
      baseUrl = 'https://mobile.iqihang.com';
  }
  if (type === 1) {
    baseUrl = `${baseUrl}/api/ark`;
    // baseUrl = `https://mobile.iqihang.com/api/ark`;
  }
  return baseUrl;
}; // 设置baseUrl

export const getWechatAppId = (type) =>
  new Promise((resolve) => {
    let currentEnv = '';
    let appId = '';
    ['test', 'dev', 'pre', 'release'].forEach((item) => {
      if (window.location.href.indexOf(item) !== -1) {
        currentEnv = item;
      }
    });
    // 开发环境
    if (process.env.NODE_ENV === 'development') {
      currentEnv = 'test';
    }
    if (type === 'pay') {
      // 微信支付用的appId
      // wx61c321630a09aec7   方舟 支付 pre 和 线上 这个 appId
      if (currentEnv === 'dev' || currentEnv === 'test' || currentEnv === 'release') {
        appId = 'wx9bdd048dbfe81bb3';
      } else {
        appId = 'wx61c321630a09aec7';
      }
    } else if (type === 'binding') {
      // （跟支付无关）dev、test现在用的  wx9bdd048dbfe81bb3
      // pre、prod、release用的  wx61c321630a09aec7
      if (currentEnv === 'dev' || currentEnv === 'test') {
        appId = 'wx9bdd048dbfe81bb3';
      } else {
        appId = 'wx61c321630a09aec7';
      }
    }
    resolve(appId);
  }); // 微信appId取值判断

export function copyTool(copyInfo) {
  return new Promise((resolve, reject) => {
    if (typeof document.execCommand !== 'function') {
      reject();
      return;
    }
    const dom = document.createElement('textarea');
    dom.value = copyInfo;
    dom.setAttribute('style', 'display: block;width: 1px;height: 1px;');
    document.body.appendChild(dom);
    dom.select();
    const result = document.execCommand('copy');
    document.body.removeChild(dom);
    if (result) {
      resolve();
    }
  });
} // 复制粘贴
export function invalidTimeCount(time) {
  if (time && time > 0) {
    const m =
      parseInt((time / 60) % 60, 10) < 10
        ? `0${parseInt((time / 60) % 60, 10)}`
        : parseInt((time / 60) % 60, 10);
    const s =
      parseInt(time % 60, 10) < 10 ? `0${parseInt(time % 60, 10)}` : parseInt(time % 60, 10);
    return `${m}分${s}秒`;
  }
  return '00 分 00 秒';
}
// 倒计时[以秒来计算]

// 优惠券有效期计算
export function couponDateTimeCalc(
  {
    receiveStart,
    receiveEnd,
    // startDateTime,
    // endDateTime,
    effectiveDays,
    effectiveTimeType,
    receiveDate,
  },
  currentTime,
) {
  const current = moment(currentTime);
  // let dateTimeInfo = `${startDateTime.format(this.formatter)} - ${endDateTime.format(this.formatter)}`;
  // this.couponInfo.dateTimeInfo = dateTimeInfo;
  let leftTime = 0;
  let couponValid = true;
  let cantType = 0;
  let dateTimeInfo;
  if (effectiveTimeType === 1) {
    const expiredTimestamp = new Date(receiveDate).getTime() + effectiveDays * 24 * 3600 * 1000;
    leftTime = expiredTimestamp - new Date(currentTime).getTime();
    if (leftTime > 0) {
      if (leftTime > 3600 * 24 * 7) {
        dateTimeInfo = expiredTimestamp;
      } else {
        const timeDuration = moment.duration(leftTime, 'seconds');
        const hours = timeDuration.hours() ? `${timeDuration.hours()} 小时` : '';
        const minutes = hours && timeDuration.minutes() ? `${timeDuration.minutes()} 分` : '';
        const seconds = timeDuration.seconds();
        this.couponInfo.dateTimeInfo = `${hours}${minutes} ${seconds} 秒后过期`;
      }
    }
  } else {
    leftTime = (this.couponInfo.endDateTime - current) / 1000;
    if (leftTime < 0 || current < receiveStart || current > receiveEnd) {
      couponValid = false;
      cantType = current < receiveStart ? 1 : 2;
    }
  }
  if (current < receiveStart) {
    couponValid = false;
    // cantTips = `${receiveStart.format(this.formatter)}  可以领取`;
  } else if (current > receiveEnd) {
    couponValid = false;
    // cantTips = '优惠券领取已到限期，下次请早点来哦～';
  }
  return {
    cantType,
    couponValid,
    leftTime,
    dateTimeInfo,
  };
}

export function replaceHyphens(timeStr) {
  return timeStr.replace(/-/g, '/');
} // 替换时间中的-连字符

export function setTokenFromCookie() {
  const cookieToken = Cookies.get('APPSESSION');
  if ((window?.navigator?.userAgent || '').includes('iqihang')) {
    // if (cookieToken) {
    //   localStorage.setItem('accessToken', cookieToken || '');
    // }
    console.log('cookieTokencookieTokencookieToken', cookieToken);
    localStorage.setItem('accessToken', cookieToken || '');
    Cookies.set('APPSESSION', '');
  }
}

// export function getLogin(APPSESSION) {
//   return new Promise((resolve, reject) => {
//     if (APPSESSION === undefined) {
//       reject();
//     }
//     // ios 处理登录回调
//     const cookieToken = APPSESSION;
//     if ((window?.navigator?.userAgent || '').includes('iqihang')) {
//       localStorage.setItem('accessToken', cookieToken || '');
//       resolve();
//     }
//   });
// }
/**
 * 节流
 */
export const Throttle = (fn, delay) => {
  // last为上一次触发回调的时间, timer是定时器
  let last = 0;
  let timer = null;
  // 将throttle处理结果当作函数返回
  // eslint-disable-next-line
  return function () {
    // 保留调用时的this上下文
    const context = this;
    // 保留调用时传入的参数
    const args = arguments;
    // 记录本次触发回调的时间
    const now = +new Date();

    // 判断上次触发的时间和本次触发的时间差是否小于时间间隔的阈值
    if (now - last < delay) {
      // 如果时间间隔小于我们设定的时间间隔阈值，则为本次触发操作设立一个新的定时器
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, delay);
    } else {
      // 如果时间间隔超出了我们设定的时间间隔阈值，那就不等了，无论如何要反馈给用户一次响应
      last = now;
      fn.apply(context, args);
    }
  };
};

export const removejscssfile = (filename, type) => {
  let targetelement;
  let targetattr;
  if (type === 'css') {
    targetelement = 'link';
    targetattr = 'href';
  } else {
    targetelement = 'script';
    targetattr = 'src';
  }
  const allsuspects = document.getElementsByTagName(targetelement);
  // eslint-disable-next-line no-plusplus
  for (let i = allsuspects.length - 1; i >= 0; i--) {
    // eslint-disable-next-line eqeqeq
    if (
      allsuspects[i] &&
      allsuspects[i].getAttribute(targetattr) !== null &&
      allsuspects[i].getAttribute(targetattr).indexOf(filename) !== -1
    ) {
      allsuspects[i].parentNode.removeChild(allsuspects[i]);
    }
  }
};

export const judgmentPlatform = () => {
  const ua = navigator.userAgent.toLowerCase();
  console.log('uauaua', ua)
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  const isOhos = /ohos/.test(ua);
  let platform = '';
  if (isIOS) {
    platform = 'ios';
  } else if (isAndroid) {
    platform = 'android';
  } else if (isOhos) {
    platform = 'HarmonyOS';
  }
  return platform;
};

// 物流类型
export function logisticsType(status) {
  let statusText = '';
  switch (Number(status)) {
    case 1:
      statusText = '中通快递';
      break;
    case 2:
      statusText = '申通快递';
      break;
    case 3:
      statusText = '韵达快递';
      break;
    case 4:
      statusText = '圆通快递';
      break;
    case 5:
      statusText = '邮政快递';
      break;
    case 6:
      statusText = '顺丰快递';
      break;
    case 7:
      statusText = '百世快递';
      break;
    case 8:
      statusText = '京东快递';
      break;
    default:
  }
  return statusText;
}
// 获取url参数
export function searchUrl(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export function getBigNum(num, type = 1) {
  const arr = [
    '一',
    '二',
    '三',
    '四',
    '五',
    '六',
    '七',
    '八',
    '九',
    '十',
    '十一',
    '十二',
    '十三',
    '十四',
    '十五',
    '十六',
    '十七',
    '十八',
    '十九',
    '二十',
    '二十一',
    '二十二',
    '二十三',
    '二十四',
    '二十五',
    '二十六',
    '二十七',
    '二十八',
    '二十九',
    '三十',
  ];
  if (type === 2) arr[1] = '两';
  return arr[Number(num) - 1];
}

export function checkIsApp() {
  return (window?.navigator?.userAgent || '').includes('iqihang');
}

export function gioJumpType(skipType) {
  let jumpType = '';
  switch (skipType) {
    case 1:
      jumpType = '链接';
      break;
    case 2:
      jumpType = '产品';
      break;
    case 3:
      jumpType = '自定义产品列表';
      break;
    case 4:
      jumpType = '产品分类列表';
      break;
    case 5:
      jumpType = '套餐';
      break;
    default:
      jumpType = '其他';
      break;
  }
  return jumpType;
}

export function gioPlatform() {
  let platform = 'H5';
  const miniSource = GetQueryValue('miniSource');
  if (whatEev() == 'miniprogram') {
    platform = '小程序';
    if (miniSource == 'zsb') {
      platform = '专升本小程序';
    }
  } else if (!checkIsApp()) {
    platform = 'H5';
  } else if (judgmentPlatform() === 'android') {
    platform = '安卓';
  } else if (judgmentPlatform() === 'ios') {
    platform = 'IOS';
  } else if (judgmentPlatform() === 'HarmonyOS') {
    platform = '鸿蒙';
  }
  return platform;
}

// 来源端口 1 PC 2 H5 3 小程序 4 IOS 5 安卓 6 ipad 7 鸿蒙
export function AIPlatform() {
  let platform = 2;
  if (whatEev() == 'miniprogram') {
    platform = 3;
  } else if (!checkIsApp()) {
    platform = 2;
  } else if (judgmentPlatform() === 'android') {
    platform = 5;
  } else if (judgmentPlatform() === 'ios') {
    platform = 4;
  } else if (judgmentPlatform() === 'HarmonyOS') {
    platform = 7;
  }
  return platform;
}

export const statusTextMap = {
  0: '首页',
  1: '课程详情页',
  2: '个人中心页',
  3: '公开课',
  4: '张宇刷题',
  5: '田静长难句',
  6: '精品专题课',
  7: '精选课程',
  8: '会员中心',
  10: '政治千题练',
  11: '管综刷题',
  12: '经综刷题',
  13: '书课学习',
  14: '田静讲真题',
  15: '408计算机刷题',
  16: '教育学刷题',
  17: '图书商城',
};

export function beforePageNameMap(data) {
  const statusMap = {
    15: '热销课程',
  };
  const status = Number(data);
  return statusMap[status] || '';
}

export function beforePageName(data) {
  const status = Number(data);
  // 0:首页 1:课程详情页、2:个人中心页

  return statusTextMap[status] || '';
}

// 进入课程详情页GIO
export function gioEnterCart(data) {
  // eslint-disable-next-line
  gio('track', 'enterCart_event', {
    platform_var: gioPlatform(),
    pageName_var: beforePageName(data),
  });
}

// gio注册埋点
export function send_registerSuccess_event(registerMethod, mobilePhone, id, extraInfo = {}) {
  gio('setUserId', id);
  const sendData = {
    registerMethod_var: registerMethod, // 注册方式
    mobilePhone_var: mobilePhone, // 手机号
    platform_var: 'H5',
    ...extraInfo,
  };
  if (whatEev() === 'miniprogram') {
    // 小程序内埋点
    const url = localStorage.getItem('redirctUrlMini'); // 触发登录的页面路径
    const initPageUrl = localStorage.getItem('initPageUrl'); // 进入到小程序的初始化页面路径
    sendData.triggerPage_var = decodeURIComponent(url);
    sendData.landingPage_var = decodeURIComponent(initPageUrl);
    sendData.source_var = '启航考研小程序';
    sendData.platform_var = '微信小程序';
  }
  gio('track', 'registerSuccess_event', sendData);
}

// 专业课学长学姐 打开咨询
export function seniorOpenChat(_this) {
  const chatUrl =
    'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=62da2340be8c8a0001b0e211';
  if (_this.$root.$data.isApp) {
    _this.$sendToApp(
      'openNewWebView',
      {
        url: chatUrl,
      },
      false,
    );
    return;
  }
  window.open(chatUrl);
}

export function GetQueryValue(queryName) {
  const query = decodeURIComponent(window.location.search.substring(1));
  const vars = query.split('&');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (String(pair[0]) === queryName) {
      return String(pair[1]);
    }
  }
  return null;
}
export function handleJumpType($this, data) {
  // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表 5套餐 7优惠券
  const {
    skipType,
    skipUrl,
    productId,
    productCategoryId,
    productAttributeJson,
    openType,
    miniAppId,
    miniProgramPath,
    communityId,
  } = data;

  switch (skipType) {
    case 1:
      if ($this.$root.$data.isApp) {
        if (openType === 2) {
          $this.$sendToApp(
            'openBrowser',
            {
              url: skipUrl,
            },
            false,
          );
        } else if (openType === 3) {
          $this.$sendToApp(
            'openTaobao',
            {
              url: skipUrl,
            },
            false,
          );
        } else if (openType === 4) {
          $this.$sendToApp(
            'toTaoBaoBrowser',
            {
              url: skipUrl,
            },
            false,
          );
        } else {
          $this.$sendToApp(
            'openNewWebView',
            {
              url: skipUrl,
            },
            false,
          );
        }
        return;
      }
      // H5跳转url
      sessionStorage.setItem('back', true);
      window.open(skipUrl);
      break;
    case 2:
      // 判断是否App
      if ($this.$root.$data.isApp) {
        $this.$sendToApp('goCourseDetail', Number(productId), false);
        return;
      }
      sessionStorage.setItem('back', 'true'); //此处是为了返回到上一页  不加会直接返回到官网首页了
      $this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: productId,
        },
      });
      break;
    case 3:
      if ($this.$root.$data.isApp) {
        $this.$sendToApp(
          'openNewWebView',
          {
            url: `${setBaseUrl('')}/ark/productList?type=1&productId=${productId}`,
          },
          false,
        );
        return;
      }
      $this.$router.push({
        path: '/productList',
        query: {
          type: 1,
          productId,
        },
      });
      break;
    case 4:
      if ($this.$root.$data.isApp) {
        $this.$sendToApp(
          'openNewWebView',
          {
            url: `${setBaseUrl(
              '',
            )}/ark/productList?type=2&productCategoryId=${productCategoryId}&productAttributeJson=${productAttributeJson || ''
              }`,
          },
          false,
        );
        return;
      }
      $this.$router.push({
        path: '/productList',
        query: {
          type: 2,
          productCategoryId,
          productAttributeJson,
        },
      });
      break;
    case 5:
      // 判断是否App
      // console.log(Number(productId));
      if ($this.$root.$data.isApp) {
        $this.$sendToApp('goToCombinationCourse', Number(productId), false);
        return;
      }

      sessionStorage.setItem('back', 'true'); //此处是为了返回到上一页  不加会直接返回到官网首页了
      $this.$router.push({
        path: '/combinationCourse',
        query: {
          combinationId: productId,
        },
      });
      break;
    case 6:
      if (miniAppId) {
        getSchemeUrl(miniAppId, miniProgramPath);
      } else {
        $this.$toast('未配置appid');
      }

      break;

    case 7:
      couonList($this, productId);
      break;
    case 8:
      reqCommunity(communityId).then((res) => {
        const { data } = res;
        $this.$communityPopup(data);
      });
      break;
    default:
  }
}
export async function getSchemeUrl(appid, path) {
  let data = {
    appid,
    path,
    envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
  };
  const res = await reqSchemeUrl(data);
  if (res?.code === 0) {
    window.location.href = res.data;
  }
}

export function homeGioAdClick(data) {
  const { skipType, title, id, adPosition_var } = data[0];
  gio('track', 'adClick_event', {
    adPosition_var, // 广告位置
    pageName_var: '首页', // 页面名称
    adSequence_var: null, // 广告序号
    adId_var: id.toString(), // 广告ID
    adName_var: title, // 广告名称
    linesBusiness_var: '考研', // 业务线
    jumpType_var: gioJumpType(skipType), // 跳转类型
    platform_var: gioPlatform(),
  });
}

export function homeGioAdShow(data) {
  const { skipType, title, id, adPosition_var } = data[0];
  gio('track', 'adShown_event', {
    adPosition_var, // 广告位置
    pageName_var: '首页', // 页面名称
    adSequence_var: null, // 广告序号
    adId_var: id.toString(), // 广告ID
    adName_var: title, // 广告名称
    linesBusiness_var: '考研', // 业务线
    jumpType_var: gioJumpType(skipType), // 跳转类型
    platform_var: gioPlatform(),
  });
}

// 内容解锁
export function ConUnlocking_GIO(data) {
  gio('track', 'ConUnlocking_event', {
    enter_var: data?.enter_var,
    UnStyle_var: data.UnStyle_var,
    courseId_var: data?.courseId_var,
    courseName_var: data?.courseName_var,
    classSize_var: data?.classSize_var,
  });
}

// 注册来源
export function getRegisterSourceInfo($this, data, type, needFun) {
  // needFun是否需要调用userInfo等方法
  const address = `${window.location.origin}/ark/${data}${window.location.search}`;
  // 4免费课程 5付费课程
  if (needFun) {
    $this
      .$sendToApp(
        'newLogin',
        {
          clientType: type,
          address,
        },
        true,
      )
      .then(async () => {
        setTokenFromCookie();
        await $this.$root.getUserInfo();
      });
  } else {
    $this.$sendToApp('newLogin', {
      clientType: type,
      address,
    });
  }
}
/**
 * 枚举类
 */
export class Enum {
  /**
   * 添加枚举字段
   * field: 枚举字段
   * label: 界面显示
   * value: 枚举值
   */
  add(field, label, value) {
    this[field] = {
      label,
      value,
    };
    return this;
  }

  /**
   * 根据枚举value获取其label
   */
  getLabelByValue(value) {
    // 字段不存在返回‘’
    if (value === undefined || value === null) {
      return '';
    }
    for (const i in this) {
      const e = this[i];
      if (e && e.value === value) {
        return e.label;
      }
    }

    return '';
  }
}

// 自定义产品数据格式
export function resetProductData(courseList) {
  courseList.forEach((item) => {
    const copyItem = deepCopy(item)
    const { productDiscountRespVO, teacherRespVOS } = item;
    Object.assign(item, {
      isArk: 1,
      salesVolume: Number(item.realSales) + Number(item.initialSales),
      courseBeginTime: item.startTime, // 开课时间
      isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
      isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
      teacherRespVOS: teacherRespVOS?.map((teacher) => ({
        teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
        name: teacher.name,
      })),
    });
    if (
      productDiscountRespVO?.isCouponDiscount &&
      productDiscountRespVO?.couponDiscount &&
      item.sellPrice > 0 &&
      !productDiscountRespVO?.promotionLabel
    ) {
      Object.assign(item, {
        promotionLabel: 4,
        originalPrice: item.sellPrice,
        sellPrice: productDiscountRespVO.discountPrice,
      });
    }
    if (productDiscountRespVO?.promotionLabel) {
      Object.assign(item, {
        promotionLabel: productDiscountRespVO?.promotionLabel,
        originalPrice: (
          Number(productDiscountRespVO.discountMinPrice) +
          Number(productDiscountRespVO.discountAmount)
        ).toFixed(2),
        sellPrice: productDiscountRespVO.discountMinPrice,
        acvitityShowTime: productDiscountRespVO?.promotionShowTime,
        acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
        acvitityEndTime: productDiscountRespVO?.promotionEndTime,
      });
    }
    if (productDiscountRespVO?.isGroupDiscount) {
      Object.assign(item, {
        promotionLabel: 5,
        originalPrice: copyItem.sellPrice,
        sellPrice: productDiscountRespVO.discountMinPrice,
      });
    }
  });
  return courseList;
}
// 套餐卡片
export function resetCoursePackage(majorCourseList) {
  majorCourseList.forEach((item) => {
    const { packageDiscountRespVO } = item;
    Object.assign(item, {
      isArk: 1,
      setType: 1,
      salesVolume: Number(item.actualSales) + Number(item.initialSales),
      isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
    });
    if (
      packageDiscountRespVO?.isCouponDiscount &&
      item.sellPrice > 0 &&
      !packageDiscountRespVO?.promotionLabel
    ) {
      Object.assign(item, {
        promotionLabel: 4,
        originalPrice: item.sellPrice,
        sellPrice: packageDiscountRespVO.payPrice,
      });
    }
    if (packageDiscountRespVO?.promotionLabel) {
      Object.assign(item, {
        promotionLabel: packageDiscountRespVO?.promotionLabel,
        originalPrice: item.sellPrice,
        sellPrice: packageDiscountRespVO.payPrice,
        acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
        acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
        acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
      });
    }
  });
  return majorCourseList;
}
// 视频总时长转换
export function setVideoDuration(time) {
  const h = parseInt(time / 3600);
  const minute = parseInt((time / 60) % 60);
  const second = Math.ceil(time % 60);

  const hours = h < 10 ? `0${h}` : h;
  const formatSecond = second > 59 ? 59 : second;
  return `${hours > 0 ? `${hours}:` : ''}${minute < 10 ? `0${minute}` : minute}:${formatSecond < 10 ? `0${formatSecond}` : formatSecond
    }`;
}
// 计算日期
export function setAppointTime(time, changeDay) {
  // 只能修改日期
  let res = Date.parse(time) + changeDay * 86400000;
  res = new Date(res);
  const year = res.getFullYear();
  const month = res.getMonth() + 1;
  const days = res.getDate();
  // return `${month}.${days}`;
  return {
    full: `${year}年${month}月${days}日`,
    mons: res,
  };
}

// 优惠券倒计时
export const timerYhqCount = function (dateTime, type) {
  const times = {};
  const d = parseInt(dateTime / 1000 / 60 / 60 / 24); // 算出天数
  const h = parseInt((dateTime / 1000 / 60 / 60) % 24); // 算出小时数
  const m = parseInt((dateTime / 1000 / 60) % 60); // 算出分钟数
  const s = parseInt((dateTime / 1000) % 60); // 算出秒数
  times.day = `${d > 0 ? `${d}天` : ''}`;
  if (type) {
    times.day = `${d > 0 && d >= 99 ? `${99}天` : d > 0 && d < 99 ? `${d}天` : ''}`;
  }
  times.hour = h > 9 ? h : `0${h}`;
  times.min = m > 9 ? m : `0${m}`;
  times.sen = s > 9 ? s : `0${s}`;
  return `${times.day}${times.hour}:${times.min}:${times.sen}`;
};

// 删除螳螂客服脚本
export const deleteMantisChat = () => {

  const scripts = document.getElementsByTagName('script');
  const link = document.getElementsByTagName('link');
  // eslint-disable-next-line no-plusplus
  const srcStr = 'https://pg-chatn9.bjmantis.net/chat/js/dist/mantis.min.js';
  const cssStr = 'http://pg-chatn9.bjmantis.net/chat/css/mbody.css';
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i] && scripts[i].src && scripts[i].src.indexOf(srcStr) !== -1) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < link.length; i++) {
    if (link[i] && link[i].href && link[i].href.indexOf(cssStr) !== -1) {
      link[i].parentNode.removeChild(link[i]);
    }
  }
  const ele = document.getElementById('MANTIS-CHAT-DIV');
  const minimizeBox = document.getElementById('minimizeBox');
  const mantisChatBox = document.getElementById('mantisChatBox');
  const mantisMinimizeMsg = document.getElementById('mantisMinimizeMsg');
  const MANTIS_INV_INNER_DIV = document.getElementById('MANTIS_INV_INNER_DIV');
  if (ele) {
    ele.parentNode.removeChild(ele);
  }
  if (mantisChatBox) {
    mantisChatBox.parentNode.removeChild(mantisChatBox);
  }
  if (minimizeBox) {
    minimizeBox.parentNode.removeChild(minimizeBox);
  }
  if (mantisMinimizeMsg) {
    mantisMinimizeMsg.parentNode.removeChild(mantisMinimizeMsg);
  }
  if (MANTIS_INV_INNER_DIV) {
    MANTIS_INV_INNER_DIV.parentNode.removeChild(MANTIS_INV_INNER_DIV);
  }
};

// 螳螂客服脚本公共设置
function setCommonLoadMantischat(id, userInfo, isAi = false) {
  let srcStr = `https://pg-chatn9.bjmantis.net/chat/js/dist/mantis.min.js?7926#${id}`;
  if (isAi) {
    srcStr = `https://iqh-zt.oss-cn-beijing.aliyuncs.com/ai_chat/V1/chat.js?type=m_modal&probeId=${id}&v=1`;
    if (document.getElementById('AI_CHAT_SCRIPT_KEY')) {
      document.head.removeChild(document.getElementById('AI_CHAT_SCRIPT_KEY'))
    }
  }
  const script = document.createElement('script');
  script.src = srcStr;
  script.id = 'AI_CHAT_SCRIPT_KEY'
  script.defer = true;
  script.setAttribute('type', 'text/javascript');
  // eslint-disable-next-line func-names
  try {
    script.onload = function () {
      window.mantis.third = {
        account: userInfo.phone,
        userId: userInfo?.id,
      };
      mantis?.requestChat();

    };
  } catch (error) {
    console.log('mantis error', error)
  }
  document.head.appendChild(script);
}

// WG-APP-产品列表 加载螳螂客服脚本
export const loadProductListMantisChat = (userInfo) => {
  let id;
  if (whatEev() == 'miniprogram') {
    id = '67653f9d9d78140001e5277b';
  } else {
    id = '67653f7524f8c40001158e7f';
  }
  setCommonLoadMantischat(id, userInfo);
};

// WG-APP-产品 加载螳螂客服脚本
const loadProductMantisChat = (userInfo, baseBusinessLine) => {
  //baseBusinessLine=2,是专升本业务线,需要单独更换探头
  let id;
  if (whatEev() == 'miniprogram') {
    id = (baseBusinessLine && baseBusinessLine === 2) ? '689c3a40873d7d0001e78a4c' : '67653ff19d78140001e5277e';
  } else {
    id = (baseBusinessLine && baseBusinessLine === 2) ? '689c302a873d7d0001e78a48' : '67653fd704b13300018ae145';
  }
  setCommonLoadMantischat(id, userInfo, false);
};

// 加载螳螂客服脚本
export const loadMantisChat = (userInfo, source, baseBusinessLine) => {
  // if (window.location.hostname === 'localhost') return; // 如果是本地开发环境，不加载螳螂，太烦人了，影响开发效率
  const pathName = window.location.pathname;
  if (['/ark/productList', '/ark/recommendList'].includes(pathName)) {
    loadProductListMantisChat(userInfo);
    return;
  }
  if (['/ark/combinationCourse', '/ark/courseDetail'].includes(pathName)) {
    loadProductMantisChat(userInfo, baseBusinessLine);
    return;
  }
  let id = '6194a29668991d6b4e202137';
  if (pathName.includes('/pullnew/')) {
    if (checkIsApp()) {
      id = '6765403104b13300018ae147';
    }
    if (whatEev() == 'miniprogram') {
      id = '6765405073dbcf0001a32fc4';
    }
  }
  if (source === 'vipCourse') {
    id = '665818671c64a1000119f4b2';
    if (checkIsApp()) {
      id = '66696197735feb0001e5a925';
    }
  }
  if (['/ark/fungame', '/ark/fungameanswer', '/ark/fungameresult'].includes(pathName)) {
    id = '6765407024f8c40001158e84';
  }
  setCommonLoadMantischat(id, userInfo);
};

/**
 *  判读是否需要加载螳螂客服
 *  userInfo: 用户信息
 *  otherInfo：但前页面需要判断的数据
 */
export const isOnloadMantisChat = (userInfo, otherInfo, source) => {
  const { popUp, id, totalOrderAmount } = userInfo;
  const { popupWindow, baseBusinessLine } = otherInfo;
  // 未登录
  if (Object.keys(userInfo)?.length === 0 && popupWindow === 0) {
    loadMantisChat(userInfo, source, baseBusinessLine);
    return;
  }
  // 以用户信息是都有数据来判断，是都已经登录了
  if (id && popUp === 0 && popupWindow === 0 && totalOrderAmount < 1000) {
    loadMantisChat(userInfo, source, baseBusinessLine);
    return;
  }
  // 如果都没有匹配成功，则移除
  deleteMantisChat();
};

export const isOnloadMantisChatHome = (userInfo) => {
  const { popUp, id, totalOrderAmount } = userInfo;
  // 未登录
  if (Object.keys(userInfo)?.length === 0) {
    loadMantisChat(userInfo);
    return;
  }
  // 以用户信息是都有数据来判断，是都已经登录了
  if (id && popUp === 0 && totalOrderAmount < 1000) {
    loadMantisChat(userInfo);
    return;
  }
  // 如果都没有匹配成功，则移除
  deleteMantisChat();
};

export const getLocalTime = () => moment().format('YYYY-MM-DD HH:mm:ss');
// 微信环境判断
export const whatEev = () => {
  const isWechatMiniProgram = /miniProgram/i.test(navigator.userAgent.toLowerCase());
  const isWechatBrowser = /MicroMessenger/i.test(navigator.userAgent);
  if (isWechatMiniProgram) {
    return 'miniprogram';
  } else if (isWechatBrowser) {
    return 'wechatBrowser';
  } else {
    return 'normal';
  }
};

//内嵌小程序登录
export const isminiLogin = (pageUrl) => {
  const [domain, searchParams] = pageUrl.split('?');
  if (searchParams) {
    const params = searchParams.split('&');
    const paramsMap = new Map();
    params.forEach((item) => {
      const [key, value] = item.split('=');
      //  console.log('key', key, value);
      if (key) {
        paramsMap.set(key, value);
      }
    });
    const entries = paramsMap.entries();
    let query = '';
    const ExcludequeryArr = ['THIRD_SESSION', 'env'];
    for (const [key, value] of entries) {
      if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
    }
    pageUrl = `${domain}?${query}`;
    const redirctUrl = encodeURIComponent(
      `/subPackages/customShareWebview/webView?url=${encodeURIComponent(pageUrl)}`,
    );
    const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
    wx.miniProgram.redirectTo({
      url: path,
    });
  }
  return;
};
// 判断是否内嵌在h5中
// export const isMiniProgram = () => {
//   const ua = navigator.userAgent.toLowerCase();
//   if (ua.includes('micromessenger')) {
//     return new Promise((resolve) => {
//       // eslint-disable-next-line no-undef
//       wx.miniProgram.getEnv((res) => {
//         if (res.miniprogram) {
//           resolve(true);
//         }
//       });
//     });
//   }
//   return new Promise((resolve) => {
//     resolve(false);
//   });
// };

export const couonList = async ($this, coupons) => {
  // 校验是否登录
  if ($this.$root.miniprogram) {
    let url = window.location.href;
    const [domain, searchParams] = url.split('?');
    if (searchParams) {
      const params = searchParams.split('&');
      const paramsMap = new Map();
      params.forEach((item) => {
        const [key, value] = item.split('=');
        //  console.log('key', key, value);
        if (key) {
          paramsMap.set(key, value);
        }
      });
      const entries = paramsMap.entries();
      let query = '';
      const ExcludequeryArr = ['THIRD_SESSION', 'env'];
      for (const [key, value] of entries) {
        if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
      }
      url = `${domain}?${query}`;
      const redirctUrl = encodeURIComponent(
        `/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`,
      );
      const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
      wx.miniProgram.redirectTo({
        url: path,
      });
    }
    return false;
  } else if (!$this.$store?.state?.userInfo?.id) {
    if ($this.$root.$data.isApp) {
      $this
        .$sendToApp('login', {}, true)
        .then(async () => {
          setTokenFromCookie();
          await $this.$root.getUserInfo();
        })
        .catch((err) => console.log(err.toString()));
    } else {
      const param = { redirect: $this.$route.path, ...$this.$route.query };
      $this.$router.push({ path: '/registrationLogin', query: param });
    }
    return false;
  }

  const couponList = coupons.split(',');
  if (couponList.length > 0) {
    getCoupons($this, couponList);
  }
};

//领取优惠券
export const getCoupons = async ($this, key) => {
  const res = await reqReceivebatchCoupon({
    couponIds: key,
    isLink: 0,
    fitPlatform: 1,
    fitEndPoint: $this.$root.$data.isApp ? 2 : 4,
    terminalMark: $this.$global.terminalMark,
  });
  if (res.code === 0) {
    $this.$toast('优惠券领取成功,请在个人中心查看');
    // coupun_todo
  } else {
    $this.$toast(res.msg);
  }
};

export function getBrowseEntrance(data) {
  // 1 vip课程体验课
  // 2 AI产品推荐
  const statusTextMap = {
    vipCourse: 1,
    aiCourse: 2,
    svipCourse: 3
  };
  return statusTextMap[data] || 0;
}
// 字典数组转对象
/**
 * 将数组对象 转对象
 * @param {*} arr 字典数组
 * @param {*} isIncludeAll 是否拿全部字典值（包含禁用掉的）
 * @returns 对象
 */
export const setDictArrToObj = async (arr, isIncludeAll = false) => {
  console.log(arr, isIncludeAll);
  const obj = {};
  arr.forEach((item) => {
    const { code, value, isDisable } = item;
    if (isIncludeAll || !isDisable) {
      obj[code] = value;
    }
  });
  return obj;
};

/**
 * 手机号码脱敏
 * @param number
 */
export const phoneNuberConvert = (number) => {
  if (!number) return '';
  const pat = /(\d{3})\d*(\d{4})/;
  const result = number.replace(pat, '$1***$2');
  return result;
};

/**
 * 金额自动补0
 * 小数部分的长度等于或大于指定的小数位数，则不做额外的补充
 * @param {*} amount  金额
 * @param {*} decimalPlaces 补齐位数
 * @returns String
 */
export const formatMoney = (amount = 0, decimalPlaces = 2) => {
  const pattern = /^(\d+)(\.\d+)?$/;
  const match = `${amount}`.match(pattern);

  if (!match) {
    throw new Error('输入格式不正确');
  }

  // eslint-disable-next-line prefer-const, no-unused-vars
  let [_, integerPart, decimalPart] = match;

  if (!decimalPart) {
    decimalPart = '.';
  }
  decimalPart = decimalPart.substring(1);
  const zerosToAdd = decimalPlaces - decimalPart.length;
  for (let i = 0; i < zerosToAdd; i++) {
    decimalPart += '0';
  }
  return `${integerPart}.${decimalPart}`;
};

export const openMiniLoginCallBack = () => {
  let url = window.location.href;
  const [domain, searchParams] = url.split('?');
  let newRedirctUrl = '';
  let miniPath = '';
  console.log(url, 'pageUrl');
  if (searchParams) {
    const params = searchParams.split('&');
    // const paramsMap = new Map();
    // console.log(44444,params)
    let url = '';
    params.forEach((item) => {
      const [key, value] = item.split('=');
      if (key === 'redirctUrl') {
        const path = decodeURIComponent(value);
        const i = path.indexOf('initPageUrl');
        const url = path.slice(0, i);
        console.log(path, 11111);
        console.log(url, 22222);
        miniPath = path.slice(0, i);
        // console.log(url, decodeURIComponent(url), 88888000, miniPath)
        newRedirctUrl = decodeURIComponent(url);
        // console.log(path,777788)
      }
      // if (key) {
      //   paramsMap.set(key, value);
      // }
    });
    // const entries = paramsMap.entries();
    // console.log(555,entries)
    let query = '';
    // const ExcludequeryArr = ['THIRD_SESSION', 'env'];
    // // eslint-disable-next-line no-restricted-syntax
    // for (const [key, value] of entries) {
    //   // console.log(666,key,value)
    //   if (!ExcludequeryArr.includes(key)) {
    //     query += `${key}=${value}&`
    //   };
    // }
    const accessToken = window.localStorage.getItem('accessToken');
    // 登录后拼上token isPwdLogin 表示手机号登录成功了
    url = `${newRedirctUrl}`;
    const redirctUrl = encodeURIComponent(`${miniPath}?url=${encodeURIComponent(url)}`);
    console.log(888, url);
    const path = `/subPackages/loginPage/loginPage?isPwdLogin=1&accessToken=${accessToken}&redirctUrl=${redirctUrl}`;
    console.log(path, 999);
    wx.miniProgram.redirectTo({
      url: path,
    });
  }
};

const getTomorrowStartTime = () => {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1); // 设置日期为明天
  tomorrow.setHours(0, 0, 0, 0); // 将时间设置为00:00:00
  return tomorrow;
};

export function GetDateStr(AddDayCount, type) {
  if (type === 1) { // xx天有效
    let dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
    const year = dd.getFullYear();
    const month = (dd.getMonth() + 1).toString().padStart(2, '0');
    const d = dd.getDate().toString().padStart(2, '0');
    const h = dd.getHours().toString().padStart(2, '0');
    const m = dd.getMinutes().toString().padStart(2, '0');
    const s = dd.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${d} ${h}:${m}:${s}`;
  } else if (type === 3) { //当天有效
    return moment().startOf('day').format('YYYY/MM/DD HH:mm');
  } else if (type === 4) { // xxx小时内有效（小于24）
    return moment().add(AddDayCount, 'hours').format('YYYY/MM/DD HH:mm');
  }
}

export function getUrlCodeFn(url, name) {
  function getUrlCode(key) {
    return (
      decodeURIComponent(
        (new RegExp('[?|&]' + key + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(
          /\+/g,
          '%20',
        ),
      ) || null
    );
  }
  return getUrlCode(name);
}

function checkVersion(version) {
  const ua = window?.navigator?.userAgent;
  if (ua.slice(ua.lastIndexOf('/') + 1) >= version) return true;
  return false;
}
export function isEbookShowUpdateToast(template) { // 5.9.2 新增
  const openStyleTemplate = ['politics', 'english', 'zzWangji', 'wkPaper'];
  if (!template) return false;
  if (!openStyleTemplate.includes(template)) return false;
  if (
    template === 'politics' &&
    ((judgmentPlatform() === 'android' && !checkVersion('5.8.4')) ||
      (judgmentPlatform() === 'ios' && !checkVersion('5.8.6')))
  )
    return true;
  if (
    template === 'english' &&
    ((judgmentPlatform() === 'android' && !checkVersion('5.9.0')) ||
      (judgmentPlatform() === 'ios' && !checkVersion('5.9.0')))
  )
    return true;

  if (
    template === 'zzWangji' &&
    ((judgmentPlatform() === 'android' && !checkVersion('5.9.2')) ||
      (judgmentPlatform() === 'ios' && !checkVersion('5.9.2')))
  )
    return true;
  if (
    template === 'wkPaper' &&
    ((judgmentPlatform() === 'android' && !checkVersion('5.9.5')) ||
      (judgmentPlatform() === 'ios' && !checkVersion('5.9.5')))
  )
    return true;
  return false;
}

export function goApp() {
  let flag = false;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      window.location = 'https://itunes.apple.com/cn/app/id1172161344';
    }
    if (navigator.userAgent.match(/openharmony/i)) {
      window.location = 'store://appgallery.huawei.com/app/detail?id=com.iqh.ark';
    }
    if (navigator.userAgent.match(/android/i)) {
      flag = true;
    }
  } else {
    const loadDateTime = Date.now();
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      window.location = 'iqihanglmh5://';
      const turnIOS = setTimeout(() => {
        const timeOutDateTime = Date.now();
        if (timeOutDateTime - loadDateTime < 2200) {
          window.location.href = 'https://itunes.apple.com/cn/app/id1172161344';
        } else {
          clearTimeout(turnIOS);
        }
      }, 2000);
    }
    if (navigator.userAgent.match(/openharmony/i)) {
      window.location = 'store://appgallery.huawei.com/app/detail?id=com.iqh.ark';
    }
    if (navigator.userAgent.match(/android/i)) {
      flag = true;
    }
  }
  return flag;
}
export function deepCopy(obj, hash = new WeakMap()) {
  if (obj === null) return null;
  if (typeof obj !== "object") return obj;
  if (obj instanceof Date) return new Date(obj);
  if (obj instanceof RegExp) return new RegExp(obj);
  if (hash.has(obj)) return hash.get(obj); // 处理循环引用

  const copy = Array.isArray(obj) ? [] : {};
  hash.set(obj, copy); // 存储原始对象和其副本的映射

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      copy[key] = deepCopy(obj[key], hash);
    }
  }
  return copy;
}

export function resetRichText(richTxt) {
  const setRichImg = richTxt
    ?.replace(/<img /g, `<img preview="${Math.round(Math.random() * 100000)}"`)
    ?.replace(/<table /g, '<table class="table"');
  return setRichImg;
  // return richTxt.replace('<img ', '<img preview="1"');
}

export function resetRichText1(richTxt) {
  const setRichImg = richTxt
    ?.replace(/<img /g, `<img preview="${Math.round(Math.random() * 100000)}"`)
    ?.replace(/<table /g, '<table class="table"');
  return setRichImg;
  // return richTxt.replace('<img ', '<img preview="1"');
}



// 存储全局验证码实例
let globalCaptchaInstance = null;
let hiddenCaptchaButton = null;
export function initCaptcha(SceneId, successCallback) {
  // 如果已经存在隐藏按钮，则使用现有的，确保整个页面共享一个验证码实例
  if (!hiddenCaptchaButton) {
    // 创建隐藏的按钮元素
    hiddenCaptchaButton = document.createElement('button');
    hiddenCaptchaButton.id = 'hidden-captcha-button';
    hiddenCaptchaButton.style.display = 'none'; // 隐藏按钮
    document.body.appendChild(hiddenCaptchaButton);
  }

  // 初始化阿里云验证码
  window.initAliyunCaptcha({
    // 场景ID
    SceneId: SceneId,
    // 验证码模式，popup表示弹出式
    mode: "popup",
    // 使用隐藏的按钮作为触发元素（使用ID选择器）
    button: '#hidden-captcha-button',
    // 验证码验证通过回调函数
    success: function (captchaVerifyParam) {
      console.log('success成功----');
      console.log(captchaVerifyParam);
      successCallback(captchaVerifyParam);
    },
    // 验证码验证不通过回调函数
    fail: function (result) {
      console.log('fail失败----');
      console.error(result);
      console.log('fail失败----');
    },
    // 绑定验证码实例回调函数
    getInstance: function (instance) {
      globalCaptchaInstance = instance;
      console.log('getInstance回调----');
      console.log(instance);
    },
    // 滑块验证和一点即过的验证形态触发框体样式
    slideStyle: {
      width: 200,
      height: 40,
    },
  });

  return globalCaptchaInstance;
}

/**
 * 触发验证码弹窗
 * 调用此函数可以手动触发验证码弹窗
 */
export function triggerCaptcha() {
  console.log(22222)
  if (hiddenCaptchaButton) {
    hiddenCaptchaButton.click();
  }
}

export async function getDeviceFingerprint() {
  const fpPromise = await FingerprintJS.load();
  const fp = await fpPromise.get();
  return fp.visitorId; // 返回设备指纹
}
